import { Box, useMediaQuery } from '@mui/material';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { BottomTabBar } from 'components/bottom-tab-bar';
import { HeaderDesktop } from 'components/header-desktop';
import { HeaderLanding } from 'components/header-landing';
import { ProfileDialog } from 'components/profile-dialog';
import theme from 'providers/theme/theme';
import type { JSX } from 'react';

export const Route = createFileRoute('/_authenticated/_landing')({
  component: LandingLayout,
});

function LandingLayout(): JSX.Element {
  const isMediumAndDown = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Box component="main" display="flex" flexDirection="column" pt={{ lg: 30 }}>
      {isMediumAndDown ? (
        <>
          <HeaderLanding />
          <BottomTabBar />
        </>
      ) : (
        <HeaderDesktop />
      )}
      <Box minHeight="100vh" width="100%" bgcolor="common.white">
        <Outlet />
      </Box>
      <ProfileDialog />
    </Box>
  );
}
